<template>
    <div class="">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2> 
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaCausacion }}</h4> 
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" :items="fechaCausacion" class="form-control">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="procesarCausacion">{{ labels.procesar }}</b-button> 
        </div>
        <ConsultaCausacion :listCausacion="listarCausacion"></ConsultaCausacion>
    </div>
</template>

<script>

import ContratoCausacion from '../../services/ContratoCausacion' 
import ConsultaCausacion from '../../components/consultaCierres/ConsultaCausacion.vue' 
export default {
    name : 'Causacion',
    components : { ConsultaCausacion },
    data: () => ({
        fechaCausacion : '',
        listarCausacion : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Causación',
                    fechaCausacion : 'Fecha causación:',
                    procesar : 'Procesar'
                }
            }else{
                return {
                    title : 'Causation',
                    fechaCausacion : 'Causation  date:',
                    procesar : 'Process'
                }
            }
        }
    },
    methods:{
        procesarCausacion(){
            const fecha = new Date
            const mes = fecha.getMonth() + 1 
            const anio = fecha.getFullYear() 
            const fechaActual = anio+'-0'+mes

            if(this.fechaCausacion >= fechaActual){ 
                this.$toast.error('La fecha causación no puede ser igual o mayor al mes actual.') 

            }else if(this.fechaCausacion != ''){ 

                let datos = {
                    'fechaCausacion' : this.fechaCausacion, 
                    'idUser' : this.$store.state.userId 
                }
                // console.log(datos); 
                ContratoCausacion.createCausacion(datos) 
                .then((res) => { 
                    this.$toast.success(res.data.message) 
                    this.consultaCausacion() 
                })
                .catch((err) => { 

                    if(err.response.status == 500){ 
                        this.$toast.error(err.response.data.error) 
                    }else{
                        this.$toast.error("Algo pasó, intentalo de nuevo") 
                    }
                })

            }else{
                this.$toast.error('Diligenciar la fecha.') 
            }
        },
        consultaCausacion(){
            ContratoCausacion.getCausacionByFecha(this.fechaCausacion) 
            .then((res) => { 
                // console.log(res.data.listContratosCausados); 
                this.listarCausacion = res.data.listContratosCausados 
            })
            .catch((error) => console.log(error)) 
        }
    }
}
</script>

<style>

</style>
